<template>
	<right-panel :datas="connects" @onClose="onClose" ref="right-panel">
		<div slot="header">
			<translate>Change Host</translate>
		</div>
		<div slot="content" class="wrapper-padding">
			<el-form ref="hostForm" :model="hostForm" class="hostForm" label-width="110px">
				<el-form-item :label="attrText.loginUsername" prop="loginUsername">
					<el-select v-model="hostForm.loginUsername" multiple value-key filterable style="width: 380px; min-width: 100%">
						<el-option v-for="(item, index) in connects" :label="item" :value="item" :key="index" style="width: 380px; min-width: 100%"></el-option>
					</el-select>
				</el-form-item>
			</el-form>
		</div>
		<div slot="footer" class="detail-btn">
			<el-button type="primary" @click="onSubmit()" :disabled="!hostForm.loginUsername.length">
				<translate>Submit</translate>
			</el-button>
			<el-button @click="$refs['right-panel'].onClose()">
				<translate>Cancel</translate>
			</el-button>
		</div>
	</right-panel>
</template>

<script>
import STORE_CONST from '../../../store/consts'
import RightPanel from '../../common/right-panel'

export default {
	name: 'WorkgroupChangeHost',
	props: {
		items: {
			required: true,
		},
	},
	data() {
		return {
			connects: null,
			hostForm: {
				loginUsername: [],
			},
		}
	},
	methods: {
		// 提取翻译文本
		getTranslateText() {
			return {
				loginUsername: this.$gettext('Login Username'),
			}
		},
		onSubmit() {
			console.log(1, '1')
			console.log(this.$ref, 'ref')
			this.$refs['hostForm'].validate((valid) => {
				if (valid) {
					let params = {
						id: this.items.project_resource_id,
						data: {
							login_username: this.hostForm.loginUsername,
						},
					}
					this.$store.dispatch(STORE_CONST.WORKGROUP.CHANGE_LOGIN_USER, params).then((res) => {
						this.$notify({
							type: 'success',
							message: this.$gettext('Change success'),
						})
						this.$emit('callback')
						this.$refs['right-panel'].onClose()
					})
				} else {
					return false
				}
			})
		},
		// 关闭创建集群
		onClose() {
			this.connects = null
			this.$emit('onClosePanel')
		},
	},
	computed: {
		attrText() {
			return this.getTranslateText()
		},
	},
	watch: {
		items: {
			handler: function (newVal) {
				console.log('---items', this.items.project_resource_login_username)
				if (this.connects) {
					this.connects = null
					setTimeout(() => {
						this.connects = this.items.login_user
					}, 300)
				} else {
					this.connects = this.items.login_user
					this.hostForm.loginUsername = this.items.project_resource_login_username ? JSON.parse(this.items.project_resource_login_username).login_username : []
				}
			},
			deep: true,
		},
	},
	components: {
		RightPanel,
	},
}
</script>



// WEBPACK FOOTER //
// workgroup-change-host.vue?c724a136